import React from "react";
import ErrorPage from "../../../../components/ErrorPage";
import Spinner from "../../../../components/Spinner";
import ChildEmptyState from "../../shared/components/ChildEmptyState";
import { PRIVACY_CHANNELS } from "../../../../features/privacy/definitions";

const StatusPill = ({ ok, yes, no }) => (
  <span
    className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${
      ok
        ? "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-100"
        : "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-100"
    }`}
  >
    {ok ? yes : no}
  </span>
);

export default function ChildPrivacyOverview({
  privacy,
  loading,
  error,
  labels,
  resolveVisibilityLabel,
}) {
  if (loading) return <Spinner />;
  if (error) return <ErrorPage message={error.message || error} />;

  if (!privacy) {
    return <ChildEmptyState title={labels.emptyTitle} />;
  }

  return (
    <div className="space-y-6 text-gray-900 dark:text-gray-100">
      <section className="rounded-2xl border border-white/70 bg-white/85 p-4 shadow-sm dark:border-gray-700 dark:bg-gray-900/40">
        <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-600 dark:text-gray-300">
          {labels.channelsTitle}
        </h3>
        <div className="mt-4 grid gap-3 sm:grid-cols-2">
          {PRIVACY_CHANNELS.map(({ key, labelKey }) => (
            <div
              key={key}
              className="flex items-center justify-between gap-3 rounded-xl border border-white/70 bg-white/90 px-3 py-2 text-sm shadow-sm dark:border-gray-700 dark:bg-gray-900/40"
            >
              <span>{labels.channelLabel(labelKey, key)}</span>
              <StatusPill ok={!!privacy?.[key]} yes={labels.allowed} no={labels.notAllowed} />
            </div>
          ))}
        </div>
      </section>

      <section className="rounded-2xl border border-white/70 bg-white/85 p-4 shadow-sm dark:border-gray-700 dark:bg-gray-900/40">
        <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-600 dark:text-gray-300">
          {labels.visibilityTitle}
        </h3>
        <p className="mt-2 text-lg font-semibold">{resolveVisibilityLabel(privacy.visibility)}</p>
        {privacy.updatedAt && (
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {labels.lastUpdated}: {new Date(privacy.updatedAt).toLocaleString()}
          </p>
        )}
      </section>

      <p className="text-xs text-gray-500 dark:text-gray-400">{labels.contactAdmin}</p>
    </div>
  );
}
